let lastClickedButton = null; // Variable to store the last clicked button

function isDesktop() {
  return window.innerWidth >= 991;
}

function handleButtonClick(button) {
  if (!isDesktop()) return; // Only toggle on desktop

  if (lastClickedButton === button) {
    document.body.classList.remove('menu-open');
    lastClickedButton = null;
  } else {
    document.body.classList.add('menu-open');
    lastClickedButton = button;
  }
}

// Search button click handling
document.querySelectorAll('.search__button-custom').forEach(function(button) {
  button.addEventListener('click', function(event) {
    event.stopPropagation();
    handleButtonClick(button);

    const nextElement = button.nextElementSibling;
    if (nextElement) {
      nextElement.classList.toggle('open-search');
    }
  });
});

  // Clicking outside menus/search closes only if desktop
document.addEventListener('click', function(event) {
  const isInsideInlineMenu = document.querySelector('.header__inline-menu')?.contains(event.target);
  const isInsideSearch = document.querySelector('.header__search')?.contains(event.target);

  if (!isInsideInlineMenu && !isInsideSearch) {
    if (isDesktop()) {
      document.body.classList.remove('menu-open');
    }

    document.querySelectorAll('.search__button-custom').forEach(function(button) {
      const nextElement = button.nextElementSibling;
      if (nextElement) {
        nextElement.classList.remove('open-search');
      }
    });

    lastClickedButton = null;
  }
});

document.addEventListener('DOMContentLoaded', function () {
  const closeSearchBtn = document.querySelector('.close-search-header');
  const searchModal = document.querySelector('.search-modal__content-bottom');

  if (closeSearchBtn) {
    closeSearchBtn.addEventListener('click', function () {
      document.body.classList.remove('menu-open');
      if (searchModal) {
        searchModal.classList.remove('open-search');
        lastClickedButton = null;
      }
    });
  }
});


  // Handle close buttons for mega menus
  document.querySelectorAll('.close-dropdown').forEach(function(button) {
    button.addEventListener('click', function() {
      document.querySelectorAll('.mega-menu').forEach(function(element) {
        element.removeAttribute('open');
      });

      if (isDesktop()) {
        document.body.classList.remove('menu-open');
      }

      lastClickedButton = null;
    });
  });

// Menu link click behavior
document.querySelectorAll('.menu-link-with-child-wrapper').forEach(function(button) {
  button.addEventListener('click', function() {
    // Remove 'menu-active' class from all other buttons and remove 'open' from their next elements
    document.querySelectorAll('.menu-link-with-child-wrapper').forEach(function(otherButton) {
      if (otherButton !== button) {
        otherButton.classList.remove('menu-active');
        var otherNextElement = otherButton.nextElementSibling;
        if (otherNextElement) {
          otherNextElement.removeAttribute('open');
        }
      }
    });
  
    // Add 'menu-active' class to the clicked button and set 'open' to its next element
    var nextElement = button.nextElementSibling;
    button.classList.add('menu-active');
    if (nextElement) {
      nextElement.setAttribute('open', '');
    }
  });
});

// Close individual menu item
document.querySelectorAll('.close-button-wrapper-inner').forEach(function(button) { 
  button.addEventListener('click', function() { 
    var parentElement = button.parentElement; 
    if (parentElement) { 
      parentElement.removeAttribute('open'); 
      if (parentElement.previousElementSibling) {
        parentElement.previousElementSibling.classList.remove('menu-active'); 
      }
    } 
  }); 
});

// Select all '.header__menu-item' elements and add event listeners
document.querySelectorAll('.header__menu-item').forEach(function(button) {
  button.addEventListener('click', function() {
    handleButtonClick(button);
  });
});

window.addEventListener("load", () => {
  const quotifyButton = document.querySelector('.product-form__buttons quotify-button button');
  if (quotifyButton) {
    quotifyButton.addEventListener('click', function () {
      quotifyButton.classList.add('loading');

      // Create a MutationObserver to watch for #quotify-frame being added to the body
      const observer = new MutationObserver((mutationsList, observer) => {
        for (const mutation of mutationsList) {
          if (mutation.type === 'childList') {
            const addedNodes = Array.from(mutation.addedNodes);
            const quotifyFrame = addedNodes.find(node => node.id === 'quotify-frame');
            if (quotifyFrame) {
              // Remove the 'loading' class from quotifyButton
              setTimeout(() => {
                quotifyButton.classList.remove('loading');
              }, 1000); // Delay for 1 second
              // Disconnect the observer
              observer.disconnect();
              break;
            }
          }
        }
      });

      // Start observing the body for child node additions
      observer.observe(document.body, { childList: true });
    });
  }
});

document.addEventListener('DOMContentLoaded', function () {
  const menuIcon = document.querySelector('.header__icon--menu');
  const mediaQuery = window.matchMedia('(max-width: 990px)');

  if (menuIcon) {
    menuIcon.addEventListener('click', function () {
      if (!mediaQuery.matches) return;

      // Wait for aria-expanded to be updated
      setTimeout(function () {
        const isExpanded = menuIcon.getAttribute('aria-expanded') === 'true';

        if (isExpanded) {
          document.body.classList.add('menu-open');
        } else {
          document.body.classList.remove('menu-open');
        }
      }, 10); // Small delay to let DOM update
    });
  }
});


window.addEventListener('load', function () {
  const relatedTab = document.querySelector('.you-might-also-like-tab');
  const bestSellerTab = document.querySelector('.best-seller-tab');
  const similarTab = document.querySelector('.similar-tab');

  const relatedBlock = document.querySelector('.related-products');
  const bestSellerBlock = document.querySelector('.best-selling');
  const similarBlock = document.querySelector('.similar-products');

  function hasVisibleChildren(element) {
    if (!element) return false;
    return Array.from(element.children).some(child => {
      return window.getComputedStyle(child).display !== 'none';
    });
  }

  // Optionally hide empty tabs (keep relatedTab visible regardless)
  if (!hasVisibleChildren(bestSellerBlock) && bestSellerTab) {
    bestSellerTab.style.display = 'none';
  }

  setTimeout(function () {
    if (!hasVisibleChildren(relatedBlock) && relatedTab) {
      relatedTab.style.display = 'none';
    }
  }, 1000);

  if (!hasVisibleChildren(similarBlock) && similarTab) {
    similarTab.style.display = 'none';
  }

  // ✅ Show Best Seller first if available
  if (hasVisibleChildren(bestSellerBlock) && bestSellerTab?.style.display !== 'none') {
    activateTab(bestSellerTab, [relatedTab, similarTab], bestSellerBlock, [relatedBlock, similarBlock]);
  } else if (hasVisibleChildren(relatedBlock) && relatedTab?.style.display !== 'none') {
    activateTab(relatedTab, [bestSellerTab, similarTab], relatedBlock, [bestSellerBlock, similarBlock]);
  } else if (hasVisibleChildren(similarBlock) && similarTab?.style.display !== 'none') {
    activateTab(similarTab, [relatedTab, bestSellerTab], similarBlock, [relatedBlock, bestSellerBlock]);
  }

  function activateTab(activeTab, otherTabs = [], showBlock, hideBlocks = []) {
    if (activeTab) activeTab.classList.add('active');
    otherTabs.forEach(tab => tab?.classList.remove('active'));

    if (showBlock) showBlock.style.display = 'block';
    hideBlocks.forEach(block => {
      if (block) block.style.display = 'none';
    });
  }

  if (relatedTab && relatedTab.style.display !== 'none') {
    relatedTab.addEventListener('click', function () {
      activateTab(relatedTab, [bestSellerTab, similarTab], relatedBlock, [bestSellerBlock, similarBlock]);
    });
  }

  if (bestSellerTab && bestSellerTab.style.display !== 'none') {
    bestSellerTab.addEventListener('click', function () {
      activateTab(bestSellerTab, [relatedTab, similarTab], bestSellerBlock, [relatedBlock, similarBlock]);
    });
  }

  if (similarTab && similarTab.style.display !== 'none') {
    similarTab.addEventListener('click', function () {
      activateTab(similarTab, [relatedTab, bestSellerTab], similarBlock, [relatedBlock, bestSellerBlock]);
    });
  }
});




document.addEventListener('DOMContentLoaded', function () {
  const specsTabs = document.querySelector('.specs-tabs');
  const gridItems = document.querySelectorAll('.specs-tabs .grid .grid__item');

  if (!specsTabs || gridItems.length === 0) return;

  const hasContent = Array.from(gridItems).some(item => item.children.length > 0);

  if (!hasContent) {
    specsTabs.style.display = 'none';
  }
});

function updateSpecsTabsHeight() {
  const container = document.querySelector('.specs-tabs');
  if (!container) return;

  let totalHeight = 0;

  // Loop through all child elements
  Array.from(container.children).forEach(child => {
    totalHeight += child.offsetHeight;

    // If child contains .accordion__content and it's visible, include its height
    const accordionContent = child.querySelector('.accordion__content');
    if (accordionContent && window.getComputedStyle(accordionContent).display !== 'none') {
      totalHeight += accordionContent.scrollHeight;
    }
  });

  container.style.height = totalHeight + 'px';
}


document.addEventListener('DOMContentLoaded', updateSpecsTabsHeight);

document.addEventListener('DOMContentLoaded', function () {
  // Select all list items within the specified unordered list
  const listItems = document.querySelectorAll('.industry-use-cases #benefits .metafield-single_line_text_field-array li');

  // Iterate over each list item and prepend the title
  listItems.forEach((item, index) => {
    // Create the title text: "Benefit 1", "Benefit 2", etc.
    const titleText = `<span class="benefit-title">Benefit ${index + 1}</span>`;
    // Prepend the title to the list item content
    item.innerHTML = titleText + item.innerHTML;
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const navSection = document.querySelector('.industry-use-cases .shopify-section:nth-child(2)');
  const firstSection = document.querySelector('.industry-use-cases .shopify-section:first-child');
  const lastSection = document.querySelector('.industry-use-cases .shopify-section:last-child');
  const stickyClass = 'is-sticky';

  if (!navSection || !firstSection || !lastSection) return;

  const navHeight = navSection.offsetHeight;

  function onScroll() {
    const scrollTop = window.scrollY || window.pageYOffset;
    const navTrigger = firstSection.offsetTop + firstSection.offsetHeight; // after first section
    const lastTop = lastSection.getBoundingClientRect().top + window.scrollY;

    // If scroll is between after first section and before last
    if (scrollTop >= navTrigger && scrollTop + navHeight < lastTop) {
      navSection.classList.add(stickyClass);
      navSection.style.position = 'fixed';
      navSection.style.top = '0';
    }
    // If scroll goes beyond last section — stop fixing
    else if (scrollTop + navHeight >= lastTop) {
      navSection.classList.remove(stickyClass);
      navSection.style.position = 'absolute';
      navSection.style.top = (lastTop - navHeight) + 'px';
    }
    // Before trigger — place it just after the first section
    else {
      navSection.classList.remove(stickyClass);
      navSection.style.position = 'absolute';
      navSection.style.top = navTrigger + 'px';
    }
  }

  window.addEventListener('scroll', onScroll);
  onScroll(); // initial check
});

document.addEventListener('DOMContentLoaded', function () {
  const sections = [
    { id: '#overview', link: '.overview-item' },
    { id: '#benefits', link: '.benefits-item' },
    { id: '.featured-products', link: '.featured-item' },
    { id: '.blog', link: '.case-item' },
    { id: '#challenges', link: '.challenges-item' },
    { id: '#solutions', link: '.solutions-item' },
    { id: '.case-studies', link: '.case-studies-item'}
  ];

  function getOffsetTop(el) {
    return el.getBoundingClientRect().top + window.pageYOffset;
  }

  function updateNavVisibility() {
    sections.forEach(({ id, link }) => {
      const section = document.querySelector(id);
      const navItem = document.querySelector(link);

      if (navItem) {
        if (!section || section.classList.contains('blocks-empty')) {
          navItem.style.display = 'none';
        } else {
          navItem.style.display = '';
        }
      }
    });
  }

  function onScroll() {
    const scrollPos = window.scrollY + 150;

    sections.forEach(({ id, link }) => {
      const section = document.querySelector(id);
      const navItem = document.querySelector(link);

      if (section && navItem && navItem.style.display !== 'none') {
        const top = getOffsetTop(section);
        const height = section.offsetHeight;

        if (scrollPos >= top && scrollPos < top + height) {
          document.querySelectorAll('.side-scroll-nav a').forEach(el => el.classList.remove('active'));
          navItem.classList.add('active');
        }
      }
    });
  }

  updateNavVisibility();
  window.addEventListener('scroll', onScroll);
  onScroll();
});


document.querySelectorAll('.challenges .image-with-text__content').forEach((contentBlock) => {
  const heading = contentBlock.querySelector('.image-with-text__heading');
  const text = contentBlock.querySelector('.image-with-text__text');

  if (heading && text) {
    // Create a new wrapper div
    const wrapper = document.createElement('div');
    wrapper.className = 'title-content-wrap';

    // Insert the wrapper before the heading
    heading.parentNode.insertBefore(wrapper, heading);

    // Move heading and text into the wrapper
    wrapper.appendChild(text);
    wrapper.appendChild(heading);
  }
});


document.body.classList.add('loading');

window.addEventListener('load', function () {
  document.body.classList.remove('loading');
});


document.addEventListener("DOMContentLoaded", function () {
  const links = document.querySelectorAll('a[target="_blank"]');
  links.forEach(link => {
    if (!link.rel.includes("noopener")) {
      link.rel += (link.rel ? " " : "") + "noopener";
    }
  });
});

